/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ablehnunggrund1Inputs */



/**

* @param {_Field_Ablehnunggrund1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ablehnunggrund1 = /** @type {((inputs?: _Field_Ablehnunggrund1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ablehnunggrund1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ablehnungsgrund")
});
export { _field_ablehnunggrund1 as "_field_ablehnungGrund" }